<template>
  <span class="right" style="width: 64%">
    {{config.warning_value}} {{unit}}
  </span>
</template>

<script>
export default {
  props: ['config'],
  computed: {
    unit: {
      get(){
        const unitType = {
          1: 'mA',
          2: 'A',
          3: '°C',
          4: 'V',
          5: ''
        }
        return unitType[this.config.loop_type]
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/component/base-loop-warning.vue